import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const doubleDoubleBadgeDefinition: BoggleBadgeDefinition = {
  category: 'letters',
  description: 'Play a word containing 2 double letters',
  iconId: 'doubleDouble',
  id: 'doubleDouble',
  level: 'common',
  lockedReveal: 'reveal',
  name: 'Double-Double',
  points: getBoggleBadgePointsForLevel('common'),
}
